import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../../components/form-controls/Button";
import Input from "../../../components/form-controls/Input";
import { SubAccountService } from "../../../services/SubaccountService";
import Select from "../../../components/form-controls/Select";
import { AgentsService } from "../../../services/AgentsService";
import { AlertService } from "../../../services/Alert";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import useModal from "../../../hooks/useModal";
import { useTranslation } from "react-i18next";
interface FormModalProps {
    show: boolean;
    status_table_id: number;
    onRequestClose: (reload: boolean) => void;
}

function FormModal({ show, onRequestClose, status_table_id }: FormModalProps) {

    const { t }= useTranslation();

    const { account } = useCurrentAccount();
    
    const modalSubRef = useRef<HTMLDivElement>(null);

    useModal(modalSubRef, show)

    const [subaccounts, setsubaccounts] = useState<any>([]);

    const defaultValues = {
        status_table_id: '',
        name: '',
        sub_account: '',
        sub_account_name: '',
        messages_restriccion: '',
    }

    const { register, handleSubmit, reset, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const closeAndReset = async (reload: boolean) => {
        await onRequestClose(reload);
        reset(defaultValues);
    }

    const submit = async (data) => {
        
        try {
            data.status_table_id = status_table_id;
            data.messages_restriccion = data.messages_restriccion ? 1: 0;

            if(data.sub_account) {
                const findSubaccount = subaccounts.find( s => +s.id === +data.sub_account )
                data.sub_account_name = findSubaccount.name;
            } else {
                data.sub_account_name = ''
            }
            await AgentsService.addState(data);

            AlertService.success('¡Éxito!', "Se ha guardado con éxito el estatus del agente")

            await closeAndReset(true);
        } catch (error) {
            console.error(error);
            AlertService.error('¡Error!',  'No se pudo guardar el estado del agente, intenta más tarde')
        }
    }

    const getSubaccounts = async() => {
        const { data } =  await SubAccountService.getSubaccounts(account.id)
        
        // subaccounts.map( a => ({ value: a.id, text: a.name }))
        setsubaccounts(data.sub_accounts)
    }

    useEffect(() => {
        getSubaccounts()
    }, []);


    return (
        <div className="modal fade" ref={modalSubRef} data-bs-backdrop="static" data-bs-keyboard="false">
            <div className="modal-dialog" role="document">
                <form onSubmit={handleSubmit(submit)}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Crear estado</h4>
                            <button type="button" className="btn-close" onClick={() => closeAndReset(false)}></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <Input label={t("config.status-agent.name-label")} errors={errors.name} {...register('name', { required: true })} />
                            </div>
                            <div className="mb-3">
                                <Select
                                    label={t("config.status-agent.subaccount-label")}
                                    data={ [{value: '', text: t("config.status-agent.no-subaccount")}].concat(subaccounts.map( a => ({ value: a.id, text: a.name }))) }
                                    errors={errors.sub_account}
                                    {...register('sub_account')}
                                />
                            </div>
                            <div className="form-check mb-3">
                                <input type="checkbox" className="form-check-input" id={'messages_restriccion'} {...register(`messages_restriccion`)} />
                                <label className="form-check-label" htmlFor={'messages_restriccion'} >{t("config.status-agent.checkbox-assignment")}</label>
                            </div>

                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-white btn-sm" onClick={() => closeAndReset(false)}>{t("btn-cancel")}</button>
                            <Button type="submit" className="btn btn-primary btn-sm" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t("btn-save")}</Button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default FormModal